export default "__VITE_ASSET__DGJkd55y__"